import React from 'react';
import PropTypes from 'prop-types';
import { IconText } from 'components/core/IconText';
import { Paragraph } from 'components/atoms/Typography';
import greenTick from 'assets/images/features-amenities/greenTick.svg';
import './FeaturesItem.scss';

const FeaturesItem = ({ featuresData }) => {
	const renderFeatureSection = (section) => (
		<div className="features-section">
			{section.title && (
				<Paragraph className="features-title">
					{section.title.toUpperCase()}
				</Paragraph>
			)}
			<ul className="features-list">
				{section.content.map(
					(feature, index) =>
						feature.hasAttribute && (
							<li key={index}>
								<IconText
									src={greenTick}
									alt={feature.label}
									size={'standard'}
									weight={'standard'}
									color={'black'}
									lazyLoad={true}
								>
									{feature.label}
								</IconText>
							</li>
						),
				)}
			</ul>
		</div>
	);

	return (
		<div className="features-container">
			<div className="features-grid">
				{featuresData.map((section, index) => (
					<div key={section.title || `section-${index}`}>
						{renderFeatureSection(section)}
					</div>
				))}
			</div>
		</div>
	);
};

FeaturesItem.propTypes = {
	featuresData: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			content: PropTypes.arrayOf(
				PropTypes.shape({
					rank: PropTypes.number,
					label: PropTypes.string.isRequired,
					key: PropTypes.string.isRequired,
					hasAttribute: PropTypes.bool.isRequired,
				}),
			).isRequired,
		}),
	),
};

FeaturesItem.defaultProps = {
	featuresData: [],
};

export default FeaturesItem;
